import type { CurrenciesListResponse } from '@cvo/domain';
import { computed } from 'vue';
import { alwaysGetCached } from '~/utils/cachingStrategy';

export function useCurrencies() {
  const api = useApi();
  const userStore = useUserStore();

  const { data: currencies, pending: isLoading, error, refresh } = useLazyAsyncData(
    'currencies',
    () =>  api.currencies.list().then(response => response.data || []),
    {
      default: () => [] as CurrenciesListResponse,
      getCachedData: alwaysGetCached,
    },
  );

  const hasMultipleCurrencies = computed(() => currencies.value.length > 1);

  // Set first currency as default if user's currency is not in the list or not set
  watch(currencies, (newCurrencies) => {
    if (newCurrencies.length > 0 && !newCurrencies.includes(userStore.currency)) {
      userStore.selectedCurrency = newCurrencies[0]!;
    }
  });

  return {
    currencies,
    hasMultipleCurrencies,
    isLoading,
    error: readonly(error),
    refresh,
  };
}
